<template>
  <div>
      <el-tabs type="border-card">
        <el-tab-pane label="承诺卡">
          <div class="myCont-Head">
            <el-button type="primary" @click="handAdd()">新建</el-button>
          </div>
          <el-table
            :data="tableData1"
            style="width: 100%;margin-top:20px"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="number" label="编号"></el-table-column>
            <el-table-column prop="departmentVo.name" label="部门"></el-table-column>
            <el-table-column prop="jobVo.name" label="岗位"></el-table-column>
            <el-table-column prop="commitmentDate" label="承诺时间">
              <template slot-scope="{ row }">
                <span v-if="row.commitmentDate">{{ row.commitmentDate | timeFilter }}</span>
              </template>
            </el-table-column>
            <el-table-column label="附件">
              <template slot-scope="{ row }">
                <el-link type="primary" :underline="false" @click="download(row.fileUrl, row.fileName)">{{ row.fileName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="oper" label="操作">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <el-link type="primary" @click="handChange(scope.row.id,scope.row)">编辑</el-link>｜
                  <el-link type="danger" @click="handleDel(scope.row.id)">删除</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <Page
            style="float: right;margin-top: 15px"
            :total="total"
            :page-size="s1"
            @on-change="getPromisecard"
            :current="curPage1"
          />
        </el-tab-pane>
        <el-tab-pane label="应急卡">
          <div class="myCont-Head">
            <el-button type="primary" @click="handAddEmergency()">新建</el-button>
          </div>
          <el-table
            :data="tableData2"
            style="width: 100%;margin-top:20px"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="departmentVo.name" label="部门"></el-table-column>
            <el-table-column prop="jobVo.name" label="岗位"></el-table-column>
            <el-table-column prop="place" label="发生地点"></el-table-column>
            <el-table-column prop="craftFileName" label="工艺附件">
              <template slot-scope="{ row }">
                <el-link :underline="false" type="primary" @click="download(row.craftFileUrl, row.craftFileName)">{{ row.craftFileName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="附件">
              <template slot-scope="{ row }">
                <el-link :underline="false" type="primary" @click="download(row.fileUrl, row.fileName)">{{ row.fileName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
            <el-table-column prop="oper" label="操作">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <el-link type="primary" @click="handChange2(scope.row.id,scope.row)">编辑</el-link>｜
                  <el-link type="danger" @click="handleDel2(scope.row.id)">删除</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <Page
            style="float: right;margin-top: 15px"
            :total="total2"
            :page-size="s1"
            @on-change="getEmergecard"
            :current="curPage2"
          />
        </el-tab-pane>
        <el-tab-pane label="应知卡">
          <div class="myCont-Head">
            <el-button type="primary" @click="handAddKnow()">新建</el-button>
          </div>
          <el-table
            :data="tableData3"
            style="width: 100%;margin-top:20px"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="departmentVo.name" label="部门"></el-table-column>
            <el-table-column prop="number" label="编号"></el-table-column>
            <el-table-column prop="jobVo.name" label="岗位"></el-table-column>
            <el-table-column label="风险等级">
              <template slot-scope="{ row }">
                <span v-if="row.riskLevel">{{ riskLevelArr[row.riskLevel - 1].label }}</span>
              </template>
            </el-table-column>
            <el-table-column label="安全指示标志">
              <template slot-scope="{ row }">
                <span v-if="row.safetyWarningLabel">{{ saftyArr[row.safetyWarningLabel - 1].label }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
            <el-table-column label="附件">
              <template slot-scope="{ row }">
                <el-link :underline="false" type="primary" @click="download(row.fileUrl, row.fileName)">{{ row.fileName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="oper" label="操作">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <el-link type="primary" @click="handChange3(scope.row.id,scope.row)">编辑</el-link>｜
                  <el-link type="danger" @click="handleDel3(scope.row.id)">删除</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <Page
            style="float: right;margin-top:15px"
            :total="total3"
            :page-size="s1"
            @on-change="getKonwncard"
            :current="curPage3"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
import { downLoadDocument } from "@/api/downLoad"
export default {
  data() {
    return {
      currentPage: 1,
      s1: 10,
      total: 0,
      total2: 0,
      total3: 0,
      tableData1: [
        {
          name: "",
          dep: "",
          job: "",
          gmtCreate: "",
          gmtModified: ""
        }
      ],
      curPage1: 1,
      tableData2: [
        {
          name: "",
          dep: "",
          job: "",
          gmtCreate: "",
          gmtModified: ""
        }
      ],
      curPage2: 2,
      tableData3: [
        {
          name: "",
          dep: "",
          job: "",
          gmtCreate: "",
          gmtModified: ""
        }
      ],
      curPage3: 3,
      // 风险等级数组
      riskLevelArr: [
        { label: "一级", value: 1 },
        { label: "二级", value: 2 },
        { label: "三级", value: 3 },
        { label: "四级", value: 4 }
      ],
      // 安全指示标示数组
      saftyArr: [
        { label: '指示标志', value: 1 },
        { label: '警示作业安全警示标志', value: 2 },
        { label: '逃生避难警示标志', value: 3 },
        { label: '风向警示标志', value: 4 },
      ],
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    getPromisecard(page) {
      this.curPage1 = page;
      let formdata = new FormData();
      formdata.append("curPage", page);
      formdata.append("limit", 10);
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getPromisecard)
        .openLoad()
        .startPost(formdata)
        .then(res => {
          this.tableData1 = res.body.data;
          this.total = res.body.cum;
        });
    },
    getKonwncard(page) {
      this.curPage3 = page;
      let formdata = new FormData();
      formdata.append("curPage", page);
      formdata.append("limit", 10);
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getKonwnCard)
        .openLoad()
        .startPost(formdata)
        .then(res => {
          this.tableData3 = res.body.data;
          this.total3 = res.body.cum;
        });
    },
    getEmergecard(page) {
      this.curPage2 = page;
      let formdata = new FormData();
      formdata.append("curPage", page);
      formdata.append("limit", 10);
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getEmergecard)
        .openLoad()
        .startPost(formdata)
        .then(res => {
          this.tableData2 = res.body.data;
          this.total2 = res.body.cum;
        });
    },
    handAdd() {
      this.$router.push({
        path: "/processManager/editer"
      });
    },
    handAddKnow() {
      this.$router.push({
        path: "/processManager/addknowCard"
      });
    },
    //应急卡
    handAddEmergency() {
      this.$router.push({
        path: "/processManager/addEmerger"
      });
    },
    handChange2(id, row) {
      this.$router.push({
        name: "addEmerger",
        params: { key: row }
      });
    },
    handChange(id, row) {
      // console.log(id)
      // console.log(row)
      this.$router.push({
        name: "addEditer",
        params: { key: row }
      });
    },
    handChange3(id, row) {
      this.$router.push({
        name: "addknowCard",
        params: { key: row }
      });
    },
    handleDel(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").delPromisecard + id
        )
        .openLoad()
        .startDel()
        .then(res => {
          if (res.result == "success") {
            if (this.tableData1.length <= 1 && this.curPage1 > 1) {
              this.curPage1 -= 1;
            }
            this.getPromisecard(this.curPage1);
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
    },
    handleDel3(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").delKonwnCard + id
        )
        .openLoad()
        .startPost()
        .then(res => {
          if (res.result == "success") {
            if (this.tableData3.length <= 1 && this.curPage3 > 1) {
              this.curPage3 -= 1;
            }
            this.getKonwncard(this.curPage3);
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
    },
    handleDel2(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").delEmergecard + id
        )
        .openLoad()
        .startDel()
        .then(res => {
          if (res.result == "success") {
            if (this.tableData2.length <= 1 && this.curPage2 > 1) {
              this.curPage2 -= 1;
            }
            this.getEmergecard(this.curPage2);
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
    },
    handleSizeChange(val) {
      this.sizePage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPromisecard(this.currentPage);
    },

    // 下载文件
    download(url, name) {
      downLoadDocument(url, name)
    }
  },
  created() {
    this.getPromisecard(1);
    this.getKonwncard(1);
    this.getEmergecard(1);
  }
};
</script>

<style scoped>
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 160px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
